module.exports = __webpack_public_path__ + "img/no_join.23ee321.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/no_join.png
// module id = lJCM
// module chunks = 1 87